<template>
  <div class="price-card">
    <div class="tip" v-if=" $store.state.plat_id!='120' || type!='live'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2是  1不是-->
            <img :src="$free" v-if="cardData.is_free==2"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <van-image class="price-cover" fit="cover" 
    :error-icon="$placeImg"
    :loading-icon="$placeImg"
     :src="cardData.cover_mobile || cardData.img_url" alt=""></van-image>
    <div class="price-msg">
      <template v-if="!desShow">
        <div class="price-name ellipsis_two">{{ cardData.name }}</div>
      </template>
      <template v-else>
        <div class="price-name ellipsis">{{ cardData.name }}</div>
        <div class="price-des ellipsis_two">{{ cardData.description }}</div>
      </template>
      <div class="price"  v-if="plat!=120 && type!='live' && !hidePrice" >
        ¥ {{ cardData.price }}
      </div>
      <div class="btn"  v-if="btnText" >
        {{ btnText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
    type: {
      type:String,
      default : ''
    },
    btnText: {
      type:String,
      default : ''
    },
    desShow:{
      type: Boolean,
      default : false
    },
    hidePrice:{
      type: Boolean,
      default : false
    }
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
  },
  data() {
    return {};
  },
  methods: {
    
  },
};
</script>

<style scoped lang="scss">
.price-card {
  width: 100%;
  height: 167px;
  margin-bottom: 26px;
  display: flex;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  .tip{
    position: absolute;
    top:0;
    left:30px;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
}

.price-card:last-of-type {
  /* margin-bottom: 0; */
}

.price-cover {
  width: 296px;
  height: 167px;
  border-radius: 12px;
  display: block;
  flex: 0 1 296px;
  margin-right: 26px;
  overflow: hidden;
}

.price-msg {
  flex: 0 1 375px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  width: 375px;
}

.price-name {
  font-size: 32px;
  color: #333;
  font-weight: 600;
  width: 100%;
  margin-bottom: 10px;
}

.price-des {
  font-size: 28px;  
  color: #666;
  font-weight: 400;
  width: 100%;
  margin-bottom: auto;
  
}

.price {
  font-size: 24px;
  color: #ff4d41;
  font-weight: 600;
}
.btn{
  width: 300px;
  height: 56px;
  background: #F5F7FA;
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 28px;
  color: #144094;
}
</style>>
